import { render, staticRenderFns } from "./feedback-reply.vue?vue&type=template&id=6a3e2480&scoped=true"
import script from "./feedback-reply.vue?vue&type=script&lang=js"
export * from "./feedback-reply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3e2480",
  null
  
)

export default component.exports